import globals from "imports/globals";
import $ from "cash-dom";
import { gsapTrigger as WyPt } from "Utilities";
// import { gsap } from "gsap";
// import { SplitText } from "gsapBonus";

const component = (function () {
    /**
     * Initialize Hero instances
     */
    $(document).ready(function () {
        if ($(".split-text").length) {
            if (globals.debug) console.log("component-split-text initialized");

            function animateText(_array, _stagger) {
                $(_array).each(function (_i, _el) {
                    setTimeout(function () {
                        $(_el).addClass("on");
                    }, _i * _stagger);
                });
            }
            // gsap.registerPlugin(SplitText);

            $(".split-text").each(function (_i, _el) {
                var instance = $(_el);

                new WyPt({
                    element: instance[0],
                    offset: {
                        top: "top-bottom",
                        bottom: "bottom-top",
                    },
                    callback: {
                        enter: function (_el) {
                            var chars = $(_el).find(".char");
                            $(chars).each(function (_i, _el) {
                                setTimeout(function () {
                                    $(_el).addClass("on");
                                }, _i * 30);
                            });
                        },
                        leave: function (_el) {
                            var chars = $(_el).find(".char");
                            $(chars).each(function (_i, _el) {
                                setTimeout(function () {
                                    $(_el).removeClass("on");
                                }, _i * 30);
                            });
                        },
                    },
                    // pointMode: true,
                });

                /*
                gsap.from(instance.chars, {
                    duration: 1,
                    y: 100,
                    autoAlpha: 0,
                    stagger: 0.05,
                });
                */
            });
        }
    });
})();

export default component;
